import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { IntegrationsState } from '../store/models/integrations-state.model';
import * as IntegrationsActions from '../store/actions/integrations.actions';
import { selectLoading, selectCurrentProcess } from '../store/selectors/integrations.selectors';

@Injectable()
export class IntegrationsService {
  constructor(private store: Store<IntegrationsState>) {}

  dispatchSetVoluntaryChangeProcess() {
    this.store.dispatch(IntegrationsActions.SetIntegrationsVoluntaryChange());
  }

  dispatchSetInvoluntaryChangeProcess() {
    this.store.dispatch(IntegrationsActions.SetIntegrationsInvoluntaryChange());
  }

  selectIsLoading() {
    return this.store.pipe(select(selectLoading));
  }

  selectCurrentProcess() {
    return this.store.pipe(select(selectCurrentProcess));
  }
}
